import React, { useCallback } from 'react';
import { Content, Button } from '@leverege/ui-elements';
import { TitleBar } from '@leverege/ui-plugin';
import { GlobalState } from '@leverege/ui-redux';
import Factory from './PairResultRendererFactory';
import S from './PairingFlow.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function PairResult(props) {
  const {
    areaClassName,
    footerClassName,
    onClose,
    asset,
    assetId,
    tracker,
    trackerId,
    sale,
    saleDeviceId,
    type = 'success',
    actions,
    onReset: pOnReset,
    error,
    pairing,
    selling,
    titleVariant,
    titleIcon,
    noRetry
  } = props;
  const header = pairing ? 'Pair Locator to Vehicle' : 'Unpair Locator From Vehicle';
  const action = pairing ? 'Pairing' : 'Unpairing';
  const result = type === 'success' ? 'Successful' : 'Unsuccessful';
  const cancelText = type === 'success' ? 'Done' : 'Cancel';
  const otherText = type === 'success' ? `${pairing ? 'Pair' : 'Unpair'} Another` : noRetry ? 'Okay' : 'Try Again';
  const tabId = pairing ? 'pair' : 'unpair';
  const message = selling ? `${action} ${result} & Sale Complete` : `${action} ${result}`;

  // defaults to vin if getScreenProps isnt able to correctly get assetId and assetId becomes null
  const defaultAssetId = assetId || asset.data.vin;
  const onClick = useCallback(({
    data
  }) => {
    let action;
    if (data === 'asset') {
      action = actions.goTo(asset.id);
    } else if (data === 'tracker') {
      action = actions.parent().child('locators').goTo(`${tracker.id}`);
    } else if (data === 'sale') {
      action = actions.parent().child('sales').goTo(`${sale?.id || saleDeviceId}`);
    }
    GlobalState.dispatch(action);
    onClose();
  }, [asset, tracker, actions]);
  const onReset = useCallback(({
    data
  }) => {
    pOnReset(data, type === 'success');
  }, [pOnReset]);
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsxs(Content.Header, {
      children: [/*#__PURE__*/_jsx(TitleBar, {
        variant: titleVariant,
        title: header,
        icon: titleIcon
      }), /*#__PURE__*/_jsx(Button, {
        variant: "closeDialog",
        className: S.close,
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsx(Content.Area, {
      className: areaClassName,
      children: Factory.create(error?.customType, {
        message,
        pairing,
        selling,
        trackerId,
        assetId: defaultAssetId,
        error,
        type,
        onClick
      })
    }), /*#__PURE__*/_jsxs(Content.Footer, {
      className: footerClassName,
      layout: "flex:rowMEnd",
      children: [/*#__PURE__*/_jsx(Button, {
        "data-test-id": "button.pairing.done",
        onClick: () => onClose(),
        variant: "secondary",
        children: cancelText
      }), /*#__PURE__*/_jsx(Button, {
        "data-test-id": `button.pairing.${tabId}Another`,
        variant: "primary",
        eventData: tabId,
        onClick: onReset,
        children: otherText
      })]
    })]
  });
}